import { Box } from '@mui/material';
import { ModalV2 } from '../../shared/modal/modal';
import { NormalText } from '../../shared/styles';
import { deleteContactAgenda } from '../../redux/actions/agenda.actions';
import { useDispatch } from 'react-redux';

export const ModalDeleteContact = ({
  open,
  handleClose,
  idContact,
  userId,
}) => {
  const dispatch = useDispatch();

  function handleDeleteContact() {
    dispatch(deleteContactAgenda(idContact, userId));
    handleClose('deleteContact');
  }

  return (
    <ModalV2
      isOpen={open}
      title={'Delete contact'}
      handleClose={() => handleClose('deleteContact')}
      actionButtons={[
        {
          label: 'Cancel',
          onClick: () => handleClose('deleteContact'),
        },
        {
          label: 'Delete',
          onClick: handleDeleteContact,
        },
      ]}
    >
      <Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={'8px'}
          px={'24px'}
          pb={'24px'}
        >
          <NormalText>Are you sure you want to delete this contact?</NormalText>
        </Box>
      </Box>
    </ModalV2>
  );
};
